import React, { FC } from 'react';
import { ReactFacebookFailureResponse, ReactFacebookLoginInfo } from 'react-facebook-login';
import { LoginWithFacebook } from './LoginWithFacebook';
import { LoginWithGoogle } from './LoginWithGoogle';
import { LoginWithAppleId } from './LoginWithAppleID';
import { AppleLoginResponse } from '../../../models/Socials';

interface LoginWithSocialsProps {
  isAppleAvailable?: boolean;
  isGoogleAvailable?: boolean;
  isFacebookAvailable?: boolean;
  handleGoogleLogin: () => void;
  handleFacebookLogin: (res: ReactFacebookLoginInfo | ReactFacebookFailureResponse) => void;
  handleAppleLogin: (res: AppleLoginResponse) => void;
}

const defaultProps = {
  isAppleAvailable: false,
  isGoogleAvailable: false,
  isFacebookAvailable: false,
};

export const LoginWithSocials: FC<LoginWithSocialsProps> = ({
  isAppleAvailable,
  isFacebookAvailable,
  isGoogleAvailable,
  handleGoogleLogin,
  handleFacebookLogin,
  handleAppleLogin,
}) => {
  return (
    <div className="login-socials">
      {isAppleAvailable && <LoginWithAppleId onSuccess={handleAppleLogin} />}
      {isGoogleAvailable && <LoginWithGoogle onSuccess={handleGoogleLogin} />}
      {isFacebookAvailable && <LoginWithFacebook handleFacebookLogin={handleFacebookLogin} />}
    </div>
  );
};

LoginWithSocials.defaultProps = defaultProps;
